<template>
  <modalDialog class="modal--personalized" @close="close">
    <p class="" slot="header">{{ $t("articles") }}</p>
    <div slot="form" class="form">
      <div class="detail" v-for="item in articles" :key="item.code">
        <p class="detail__title detail__title--articles">
          {{ item.description }}
        </p>
        <div class="detail__details">
          <div class="item">
            <span class="item__title">{{ $t("amount") }}:</span>
            <span class="item__value">{{ item.amount }}</span>
          </div>
          <div class="item">
            <span class="item__title">{{ $t("reference") }}:</span>
            <span class="item__value">{{ item.reference }}</span>
          </div>
          <div class="item">
            <span class="item__title">{{ $t("weight") }}:</span>
            <i18n-n
              tag="span"
              class="item__value"
              :value="item.weightNet"
              v-if="item.weightNet != null"
            ></i18n-n>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button cancel class="btn btn--white modal__btn" @click="close">
        {{ $t("global.button.close") }}
      </button>
    </div>
  </modalDialog>
</template>

<script>
import modalDialog from "@/components/ModalDialogFrame.vue";

export default {
  components: {
    modalDialog
  },
  props: {
    articles: {
      required: true
    }
  },
  name: "DialogArticles",
  data: () => ({}),
  methods: {
    close() {
      this.$emit("close");
    }
  },
  mounted() {
    this.$plausible.trackEvent("showArticles");
  }
};
</script>

<style scoped>
.detail__title--articles {
  background: url("./assets/articles.svg") no-repeat;
}

.form {
  max-height: 50vh;
  overflow-y: auto;
}
</style>
